import 'core-js/stable'
import 'regenerator-runtime/runtime'

import initGlobal, { initCancelPageHeader } from '@bikemap/js/integrations/global'
import { initRegistrationForm } from './integrations/authentication'

initGlobal()
initCancelPageHeader()

const form = /** @type {HTMLFormElement} */ (document.getElementById('register'))
initRegistrationForm((form))

const emailField = /** @type {HTMLInputElement} */ (document.getElementById('reg_id_email'))
if (!emailField.value) {
    emailField.focus()
} else {
    document.getElementById('id_displayname').focus()
}
